// import external dependencies
import 'jquery';
// import 'jquery-validation/dist/jquery.validate.min.js';
// import 'js-cookie/src/js.cookie.js';
// import 'js-cookie';

// Import Smooth Scroll
import 'smooth-scrolling/smooth-scrolling.js';

//Import Animsition
import 'animsition/dist/js/animsition.min.js';

// Smooth State
// throws an error and cant find npm repo - removing
// import 'smoothState-js-master/src/jquery.smoothState.js';

// Lightslider
import 'lightslider/dist/js/lightslider.min.js';

// Import everything from autoload
import './autoload/_bootstrap.js';


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import examplePage from './routes/examplePage';
import theSalon from './routes/theSalon';
import contact from './routes/contact';
import experience from './routes/experience';
import templateSalonLocation from './routes/templateSalonLocation';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Example Page
  examplePage,
  // The Salon
  theSalon,
  // Contact
  contact,
  // Experience
  experience,

  // Salon Location Template
  templateSalonLocation,
  
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js